import React from 'react';
import '../../../css/artist/chats/ArtistEventNotes.css';
import ChatNotesPanel from '../../common/chat/notes/ChatNotesPanel';

const API_URL = process.env.REACT_APP_API_URL;

const ArtistEventNotesPanel = ({ eventId, onModeChange, onNotesChanged }) => (
  <ChatNotesPanel
    ownerId={eventId}
    rootClassName="artist-notes-panel"
    title="ノート"
    buildListUrl={(ownerId, offset = 0, limit = 20) => `${API_URL}/api/artist/event-notes/${ownerId}?offset=${offset}&limit=${limit}`}
    createUrl={`${API_URL}/api/artist/event-notes`}
    buildUpdateUrl={(noteId) => `${API_URL}/api/artist/event-notes/${noteId}`}
    buildDeleteUrl={(noteId) => `${API_URL}/api/artist/event-notes/${noteId}`}
    buildDetailUrl={(noteId) => `${API_URL}/api/event-notes/detail/${noteId}`}
    onModeChange={onModeChange}
    onNotesChanged={onNotesChanged}
    openDetailEventName="artist-notes-open-detail"
    closeDetailEventName="artist-notes-close-detail"
    closeImageEventName="artist-notes-close-image"
  />
);

export default ArtistEventNotesPanel;
